import React, { FC } from 'react';
import { StyledOcAnchor } from 'common/Link';
import { useTenantCode } from 'utils/hooks/useTenantConfig';
import { useHistory } from 'react-router-dom';
import { RateCardModel } from '@utmost.co/enterprise-models';
import cloneDeep from 'lodash-es/cloneDeep';
import { ENGAGEMENTS_TAB, PATH_SCHEMA } from 'src/components/pages/settings/Engagements/EngagementsHome.constants';
import { navItems } from 'src/components/pages/settings/Engagements/EngagementsHome.paths';

interface Props {
  rateCard: RateCardModel;
}

export const RateCardRowLink: FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const { push } = useHistory();
  const tenantCode = useTenantCode();

  const path = navItems.find((n) => n.path === ENGAGEMENTS_TAB.RATE_CARDS)?.path;
  const sideDrawerRoute = `/${tenantCode}${PATH_SCHEMA}/${path}/details/${rateCard.uid}`;

  return (
    <StyledOcAnchor
      onClick={() => {
        push({ pathname: sideDrawerRoute, state: cloneDeep(rateCard) });
      }}
      data-test="cell-rate-card-name"
    >
      {rateCard.name ?? '-'}
    </StyledOcAnchor>
  );
};
